<template>
  <BaseModal
    :heading="$t('marketing.email.automated_emails.rebook_default.title')"
    small
    grey
    :parentRoute="{
      name: parentRouteName
    }"
  >
    <Flex
      direction="column"
      :class="$style.rebookDisabledVisual"
    >
      <RebookDisabledVisual />
    </Flex>
    <BaseCard label="default">
      <template #header>
        <BaseText
          iconAfter="edit"
          :routerLink="{ name: 'rebook-reminder-services' }"
        >
          {{ $t('global.actions.edit') }}
        </BaseText>
      </template>
      <Flex direction="column">
        <BaseText>
          {{ $t('marketing.email.automated_emails.rebook_default.info') }}
        </BaseText>
      </Flex>
    </BaseCard>
    <template #footer>
      <BaseButton
        @click="onSave"
        v-test="'rebook-default-setup-save'"
      >
        {{ $t('marketing.email.automated_emails.rebook_default.go_to_dashboard') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import BaseText from '@/components/BaseText.vue';
import router from '@/router';
import RebookDisabledVisual from '../../email/templates/rebook-reminder/RebookDisabledVisual.vue';

const parentRouteName = 'rebook-reminder-dashboard';

const onSave = () => {
  router.push({ name: parentRouteName });
};
</script>

<style
  lang="scss"
  module
>
.rebookDisabledVisual {
  display: flex;
  justify-content: center;
  margin-bottom: $spacing;
}
</style>
